import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { styles } from './action-window-styles';

const ActionWindowCouponLines: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles({});
  const { ejItems, selectedItem } = props;
  const { t } = useTranslation();
  return (
    <>
      {ejItems.map(item => {
        if (item.PromotionId && selectedItem.CouponRedemptionsIds?.includes(item.PromotionId)) {
          return (
            <Grid key={item.PromotionId} container style={{ height: 'fit-content' }}>
              <Grid item>
                <span
                  className={classes.couponLine}
                  data-testid={`action-window-coupon-line-${item.PromotionId}`}
                >
                  {t(item.Description || '')}
                </span>
              </Grid>
            </Grid>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

interface Props {
  selectedItem: IElectronicJournalRecord;
  ejItems: IElectronicJournalRecord[];
}

export default ActionWindowCouponLines;
